import { render } from "./TournamentResultListDMM.vue?vue&type=template&id=27d21ca3&scoped=true"
import script from "./TournamentResultListDMM.vue?vue&type=script&lang=js"
export * from "./TournamentResultListDMM.vue?vue&type=script&lang=js"

import "./TournamentResultListDMM.vue?vue&type=style&index=0&id=27d21ca3&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d21ca3"]])

export default __exports__